import Config from "./config";
import axios from 'axios';
import Utils from "./utils";

var DataLayer = {
    search(query) {
        if (!Config.allowBulkNumberSearch) {
            if (!isNaN(query.trim())) {
                return Promise.resolve({data: []});
            }
        }
        let url = `${Config.wsUrl}/product/${encodeURIComponent(Utils.makeSafe(query))}`;
        if (!url) return Promise.reject("The application seems to be misconfigured. Please contact your administrator.");
        return axios.get(url);
    },
    getMaterials(bulkNumber, productTitle) {
        if (!bulkNumber) {
            return Promise.resolve({data: []});
        }
        productTitle = productTitle || "";
        let url = `${Config.wsUrl}/material/${bulkNumber}?product=${productTitle}`;
        if (!url) return Promise.reject("The application seems to be misconfigured. Please contact your administrator.");
        return axios.get(url);
    },
    getSDSFiles(materialNumber) {
        if (!materialNumber) return Promise.reject("Invalid material number. Please contact your administrator.");
        let url = `${Config.wsUrl}/file/${materialNumber}`;
        return axios.get(url);
    },
    getProductFiles(productId) {
        if (!productId) return Promise.reject("Invalid product id. Please contact your administrator.");
        let url = `${Config.wsUrl}/product/file/${productId}`;
        return axios.get(url);
    },
    recordDownload(postData) {
        if (!postData) return Promise.reject("Invalid download information. Please contact your administrator.");
        return axios.post(Config.downloadWsUrl, postData);
    },
    downloadFile(url) {
        return axios.get(url, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        });
    }
};

export default DataLayer;